<template>
<div class="main-graph-window">
  <div class="menu-wrapper">
    <ul class="sub-menu-dropup">
      <li

          class="dropdown-item btn btn-block btn-light-gray dp"
          :style="mainSector === tab.alias?{ backgroundColor: tab.color }:''"
          v-for="tab in graphTabs"
          :key="tab"
          @click="TabClick(tab)"
          :class="{
            active: mainSector === tab.alias,
            loading: selectedTab === tab.alias.toUpperCase(),
            'cal-match':
              selectedCalendarType.alias === tab.CalendarSection &&
              selectedTab === tab.alias,
              longTitleFontSize: tab.name.length > 10
          }"
      >

        <span

            class="dropdown-item-left"
        >{{ tab.name }}</span
        >
      </li>
    </ul>
    <div class="arrow-down">
      <!--        <div class="presets-container dropup">-->
      <!--          <button-->
      <!--            class="btn btn-info pre-btn dropdown-toggle"-->
      <!--            data-toggle="dropdown"-->
      <!--          >-->
      <!--            PRESETS-->
      <!--          </button>-->
      <!--          <div class="dropdown-menu sub-menu-presets-tab">-->
      <!--            <button-->
      <!--              class="btn btn-block preset-tab"-->
      <!--              v-for="subTab in presetsTabs"-->
      <!--              :key="subTab.id"-->
      <!--              @click.stop="setPresetFromTab(subTab, tab)"-->
      <!--              :class="{-->
      <!--                active: selectedCalendarType.preset === subTab.alias-->
      <!--              }"-->
      <!--            >-->
      <!--              {{ subTab.name }}-->
      <!--            </button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <i-->
      <!--          :class="{-->
      <!--            disabled_scroll: paginate(graphTabs)[tabPaginate + 1] === undefined-->
      <!--          }"-->
      <!--          class="fas fa-angle-down"-->
      <!--          @click="tabPaginate++"-->
      <!--        ></i>-->
      <!--        <i-->
      <!--          :class="{-->
      <!--            disabled_scroll: paginate(graphTabs)[tabPaginate - 1] === undefined-->
      <!--          }"-->
      <!--          class="fas fa-angle-up"-->
      <!--          @click="tabPaginate&#45;&#45;"-->
      <!--        ></i>-->
    </div>
  </div>
        <scheduled-calls-charts
          v-if="mainSector === 'call_again'"
          :main-sector="mainSector"
          :main-data="mainData"
          :tabs="tabs['call_again']"
          :presets-tabs="presetsTabs"
          :stats-tabs="statsTabs"
        />

        <dp-charts
          v-if="mainSector === 'deposits' || mainSector === null"
          :main-sector="mainSector"
          :main-data="mainData"
          :tabs="tabs['deposits']"
          :presets-tabs="presetsTabs"
          :stats-tabs="statsTabs"
        />

        <reg-charts
            v-if="mainSector === 'register'"
            :main-sector="mainSector"
            :presets-tabs="presetsTabs"
        />
</div>
</template>

<script>
import RegCharts from "./regNewCharts.component";
import DpCharts from "./DpCharts.component";
import ScheduledCallsCharts from "./ScheduledCallsCharts.component";
import {mapGetters, mapState} from "vuex";



export default {
name: "DefaultCharts.component",
  props:{
    mainData: {
      required: true,
      type: Object
    },
    mainSector: {
      required: true,
      type: String
    },
    tabs: {
      type: Object,
      required: true
    },
    presetsTabs: {
      type: Array,
      required: true
    },
    statsTabs: {
      type: Array,
      required: true
    },
    mainView: {
      type: String,
      required: true
    }
  },
  components:{
    RegCharts,
    DpCharts,
    ScheduledCallsCharts
  },
  computed: {
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "showReset",
      "multiSelectChartData",
      "selectedCalendarType",
      "generalQueryObject",
      "clickFromChart",
      "updateDepAfterCongrats",
      "clickedOnMatrixCountries",
        "chartsViewBlocks",

    ])
  },
  data(){
  return{
    graphTabs:[
      {
        id:1,
        alias:'deposits',
        name:'DEPOSITS',
        CalendarSection:'DEP',
        color:'#c12fff'
      },
      {
        id:2,
        alias:'call_again',
        name:'SCH-CALLS',
        CalendarSection:'CA_F',
        color:'#ffa400'
      },
      {
        id:3,
        alias:'register',
        name:'TIME LINES',
        CalendarSection:'REG',
        color:'#00728d'
      },
    ],
    }
  },
  methods:{
    TabClick(tab){
      let blocks = Object.assign({}, this.chartsViewBlocks);
      blocks[1] = tab.alias;

      this.$store.commit("clients/setChartsViewBlocks", blocks);
    },
  }
}
</script>

<style scoped>
.main-graph-window {
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  /*padding-top: 5px;*/
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  overflow: hidden;
}

.dropdown-item {
  height: 35px;
  min-height: 8%;
  /*padding: 1px 0px;*/
  /*margin: 0px;*/
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  /*border-radius: 5px 0px 0px 5px;*/
  border-radius: 0px 5px 5px 0px;
//margin-bottom: 1px;
  background-color: white;
  border: 1px solid #e5e4e4;
  position: relative;
  z-index: 1;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-item.cal-match {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  margin-right: 36px;
}
.menu-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.menu-wrapper::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
.menu-wrapper {
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 5px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
  transform: scaleX(-1);
  margin-left: 5px;
  max-height: 195px;
}
.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
  transform: scaleX(-1);
}

.dropdown-item-left {
  margin-left: 10px;
  /*float: left;*/
  flex: 1;
  font-weight: 500;
}
.dropdown-item-right {
  width: 17px;
}
.chart-section {
  flex: 2;
  width: 55%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
}
.deposit-chart {
  width: 100%;
  min-height: 100%;
}
.longTitleFontSize {
  font-size: 9px;
}

li.active {
  background-color: #c12fff;
  color: #fff;
}
.sized_chart {
  /*max-width: 68%;*/
  /*position: relative;*/
}
.trans-dep-chart {
  position: relative;
  max-width: 13%;
  min-width: 13%;
  max-height: 100%;
  margin-left: 3px;
}
.dep-goal-chart {
  position: relative;
  max-width: 9%;
  min-width: 9%;
  max-height: 100%;
  margin-left: 3px;
}

.sub-menu-main {
  left: 67px;
  top: -1px;
  position: absolute;
  display: flex;
  max-height: 20px;
}

.sub-menu-main li {
  background-color: #f5f7ff;
  color: #0a0a0a;
  cursor: pointer;
  transform: none !important;
  max-height: 20px;
  margin-left: 1px;
  border-radius: 0px;
}
.sub-menu-main li:hover {
  cursor: pointer;
  background-color: #dedede;
}
.sub-menu-main li.active {
  /*background-color: #c12fff;*/
  color: #fff;
}
.preset-tab {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  max-width: 52px;
  margin-left: 3px;
}
.preset-tab:hover {
  background: #d7d7d7;
}
.preset-tab:active {
  background: #a8a5a5;
}
.preset-tab.active {
  background-color: #c12fff;
  color: #fff;
}
.preset-tab {
  margin-top: unset;
}
.preset-tab:focus {
  outline: none;
}
.dropdown-item-left.sub {
  margin-left: unset;
  width: 50px;
  text-align: center;
}
.loading {
  background: linear-gradient(-45deg, #c12fff, #43006b, #c12fff, #43006b);
  background-size: 500% 500%;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%;
  }

  100% {
    background-position: 100% 50%;
  }
}

/*::-webkit-scrollbar {*/
/*  display: none;*/
/*}*/
.arrow-down {
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #d2f;
  font-size: 29px;
  cursor: pointer;
}

.disabled_scroll {
  display: none;
}
.cancel-filter {
  margin-top: 2px;
  margin-left: 5px;
}

.presets-container {
  height: 20px;
  margin: 0px;
  padding: 0px;
  display: flex;
  /*position: absolute;*/
  /*top: 35px;*/
  /*left: 91px;*/
  position: relative;
  top: -8px;
  left: -75px;
  z-index: 0;
}
.pre-btn:focus {
  outline: none;
}
.pre-btn {
  height: 20px;
  font-size: 10px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sub-menu-presets-tab {
  /*max-width: 57px !important;*/
  /*min-width: 57px !important;*/
  display: flex;
  flex-direction: row;
  padding-left: 2px;
  margin-left: 63px;
  border: none;
  top: -7px;
  background: none;
}

.fa-caret-right {
  padding-left: 15px;
}
#mmain-chart-dep-sub-gn {
  padding-bottom: 7px;
  height: 169px;
}
.top-bar {
  display: flex;
  justify-content: space-evenly;
  background-color: #efefef;
  width: 100%;
  height: 15px;
  font-size: 10px;
  position: absolute;
  top: 23px;
  left: 73px;
}
.inner-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
}
.charts-main {
  flex: 2;
  width: 80%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
}
.stats-btn {
  color: #4275ec;
  font-weight: bold;
}
.stats-btn-for-line {
  color: #4275ec;
  font-weight: bold;
}
.for-line-btns {
  display: flex;
  flex-direction: row;
}
span.for-diff-in-days {
  padding-left: 8px;
}

.for-canvas-dp {
  height: 160px !important;
  padding-top: 10px !important;
}
</style>